// Copies data-value on click and plays the inline copy feedback: the copy icon swaps
// to a check, then back. Replaces the old Vue `copyToClipboard` method, which showed a
// page-level toast instead.
//
// Markup contract — the element wraps the value plus the feedback nodes:
//   <copy-to-clipboard data-value="ER1234">
//     ER1234
//     <button class="referral-copy-btn" type="button" aria-label="...">
//       <span class="referral-copy-icon">…svg…</span>
//       <span class="referral-copied-icon">✓</span>
//     </button>
//   </copy-to-clipboard>
//
// Styles: assets/component-copy-feedback.css.
(() => {
  // Keyed by element so a re-click mid-animation can cancel the run in flight —
  // otherwise the old timers strip .copied off the new one.
  const pendingTimers = new WeakMap();

  class CopyToClipboard extends HTMLElement {
    #controller;

    connectedCallback() {
      this.#controller = new AbortController();
      this.addEventListener('click', () => this.#copy(), { signal: this.#controller.signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      clearTimeout(pendingTimers.get(this));
    }

    #copy() {
      const value = this.dataset.value;
      if (!value) return;

      navigator.clipboard?.writeText(value);
      this.#animate();
    }

    #animate() {
      clearTimeout(pendingTimers.get(this));
      this.classList.add('copied');

      pendingTimers.set(
        this,
        setTimeout(() => this.classList.remove('copied'), 1000)
      );
    }
  }

  if (!customElements.get('copy-to-clipboard')) customElements.define('copy-to-clipboard', CopyToClipboard);
})();
